module.exports = __webpack_public_path__ + "static/Erfolgreiches-mobile-3ae133218fbde9d9228d2536a2de2388.gif";